import React, { useRef } from "react";
import "./BackgroundVideo.scss";


const BackgroundVideo = ({ video, autoplay, loop, key, poster, children }) => {

  const ref = useRef();

    return (
        <div className="BackgroundVideo__Container" onClick={e => ref.current.play()} >
            <video
              //  muted
                key={ key ? key : 'video'}
                ref={ref}
                autoPlay={ autoplay }
               // preload
                src={ video }
                loop={ loop }
                className="Video"
                controls
                poster={ poster ? poster : null }

            >
               { // <source src={video} type="video/mp4" />
}
                Votre navigateur ne peut pas lire cette vidéo.
            </video>
            {children && (
                <div className="Content">
                    <div className="SubContent">{children}</div>
                </div>
            )}
        </div>
    );
};
export default BackgroundVideo;